/** CPF/CNPJ: normalização (só dígitos), validação pelos dígitos verificadores e formatação para exibição. */
export function normalizeTaxId(raw) {
    return (raw ?? '').replace(/\D/g, '');
}
function cpfValid(d) {
    if (d.length !== 11 || /^(\d)\1+$/.test(d))
        return false;
    const digit = (n) => { let s = 0; for (let i = 0; i < n; i++)
        s += Number(d[i]) * (n + 1 - i); const r = (s * 10) % 11; return r === 10 ? 0 : r; };
    return digit(9) === Number(d[9]) && digit(10) === Number(d[10]);
}
function cnpjValid(d) {
    if (d.length !== 14 || /^(\d)\1+$/.test(d))
        return false;
    const digit = (n) => { const w = n === 12 ? [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2] : [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]; let s = 0; for (let i = 0; i < n; i++)
        s += Number(d[i]) * w[i]; const r = s % 11; return r < 2 ? 0 : 11 - r; };
    return digit(12) === Number(d[12]) && digit(13) === Number(d[13]);
}
export function isValidTaxId(raw) {
    const d = normalizeTaxId(raw);
    return cpfValid(d) || cnpjValid(d);
}
export function formatTaxId(raw) {
    const d = normalizeTaxId(raw);
    if (d.length === 11)
        return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}`;
    if (d.length === 14)
        return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8, 12)}-${d.slice(12)}`;
    return raw ?? '';
}
//# sourceMappingURL=tax-id.js.map